import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

interface TimeCorrection {
	appliedAt: string;
	minute: number;
}

interface BroadcastState {
	homeTeam: string;
	awayTeam: string;
	homeLogo: string;
	awayLogo: string;
	venue: string;
	location: string;
	fixtureDate: string;
	broadcastId: string | null;
	broadcastUserId: string | null;
	startTime: string | null;
	halfTimeAt: string | null;
	secondHalfStartTime: string | null;
	fullTimeAt: string | null;
	fixtureId: number | null;
	hashtagInput: string;
	timeCorrection: TimeCorrection | null;
}

const initialState: BroadcastState = {
	homeTeam: "",
	awayTeam: "",
	homeLogo: "",
	awayLogo: "",
	venue: "",
	location: "",
	fixtureDate: "",
	broadcastId: null,
	broadcastUserId: null,
	startTime: null,
	halfTimeAt: null,
	secondHalfStartTime: null,
	fullTimeAt: null,
	fixtureId: null,
	hashtagInput: "",
	timeCorrection: null,
};

const broadcastSlice = createSlice({
	name: "broadcast",
	initialState,
	reducers: {
		setHomeTeam(state, action: PayloadAction<string>) {
			state.homeTeam = action.payload;
		},
		setAwayTeam(state, action: PayloadAction<string>) {
			state.awayTeam = action.payload;
		},
		setHomeLogo(state, action: PayloadAction<string>) {
			state.homeLogo = action.payload;
		},
		setAwayLogo(state, action: PayloadAction<string>) {
			state.awayLogo = action.payload;
		},
		setVenue(state, action: PayloadAction<string>) {
			state.venue = action.payload;
		},
		setLocation(state, action: PayloadAction<string>) {
			state.location = action.payload;
		},
		setFixtureDate(state, action: PayloadAction<string>) {
			state.fixtureDate = action.payload;
		},
		setBroadcastId(state, action: PayloadAction<string>) {
			state.broadcastId = action.payload;
		},
		setBroadcastUserId(state, action: PayloadAction<string>) {
			state.broadcastUserId = action.payload;
		},
		setStartTime(state, action: PayloadAction<string>) {
			state.startTime = action.payload;
		},
		setHalfTimeAt(state, action: PayloadAction<string>) {
			state.halfTimeAt = action.payload;
		},
		setSecondHalfStartTime(state, action: PayloadAction<string>) {
			state.secondHalfStartTime = action.payload;
		},
		setFullTimeAt(state, action: PayloadAction<string>) {
			state.fullTimeAt = action.payload;
		},
		setFixtureId(state, action: PayloadAction<number>) {
			state.fixtureId = action.payload;
		},
		setHashtagInput(state, action: PayloadAction<string>) {
			state.hashtagInput = action.payload;
		},
		setTimeCorrection(state, action: PayloadAction<TimeCorrection>) {
			state.timeCorrection = action.payload;
		},
		resetBroadcast() {
			return initialState;
		},
	},
});

export const { setHomeTeam, setAwayTeam, setHomeLogo, setAwayLogo, setVenue, setLocation, setFixtureDate, setBroadcastId, setBroadcastUserId, setStartTime, setHalfTimeAt, setSecondHalfStartTime, setFullTimeAt, setFixtureId, setHashtagInput, setTimeCorrection, resetBroadcast } =
	broadcastSlice.actions;

export default broadcastSlice.reducer;
